<template>
    <!-- 售后进度 -->
    <div class="orderMain">
        <div class="order" v-for='(item,index) in scheduleList' :key='index'>
            <div class="title">{{item.tip}}</div>
            <div class="main">{{item.text}}</div>    
            <div class="time">{{item.time}}</div>
        </div>  
    </div>
</template>

<script>
	import {sendRequest} from '@/assets/public'
export default {
    data(){
        return{
            scheduleList: []
        }
    },
	mounted(){
		
		this.goDetial();
		
	},
    methods:{
		async goDetial(){
			let applySn = this.$route.query.applySn;
			let {content,status,msg} = await sendRequest('refund/applyProgress',{apply_sn:applySn})
			this.scheduleList = content;
		
		}	
    }
}
</script>

<style scoped>
.orderMain{
    background: #ffffff;
    border-top: 0.4rem solid #f5f5f5;
    padding: 0.8rem 1.2rem 0.8rem 0.8rem;
}
.order{
    padding-left: 0.88rem;
    position: relative;
    border-left: 0.02rem solid #DDDDDD;
    padding-bottom: 0.9rem;
}
.order::after{
    position: absolute;
    width: 0.56rem;
    height: 0.56rem;
    content: '';
    display: block;
    left: -0.35rem;
    top: 0;
    background: #FD3E3E;
    border: 0.08rem solid #FFD3D3;
    border-radius: 50%;
}

.title{
    font-size:0.6rem;
    font-weight:bold;
    color:rgba(253,62,62,1);
}
.main{
    font-size:0.52rem;
    color:rgba(170,170,170,1);
    line-height: 0.76rem;
    margin-top: 0.4rem;
}
.time{
    margin-top: 0.4rem;
    font-size:0.48rem;
    color:rgba(170,170,170,1);
}

</style>